import React, { useState } from "react";
import "./GrowthIndexDropdown.css"

const GrowthIndexDropdown = (props) => {
    const [index, setIndex] = useState("")

    return (
        <select className="growth-index-dropdown-lif" onChange={(e) => {
            const selectedIndex = e.target.value;
            setIndex(selectedIndex);
            props.getIndexData(selectedIndex);
        }}>
            <option value='N/A'>N/A</option>
            <option value="0">0%</option>
            <option value="1.005">0.5%</option>
            <option value="1.01">1%</option>
            <option value="1.015">1.5%</option>
            <option value="1.02">2%</option>
            <option value="1.025">2.5%</option>
            <option value="1.03">3%</option>
            <option value="1.035">3.5%</option>
            <option value="1.04">4%</option>
            <option value="1.045">4.5%</option>
            <option value="1.05">5%</option>
            <option value="1.055">5.5%</option>
            <option value="1.06">6%</option>
            <option value="1.065">6.5%</option>
            <option value="1.07">7%</option>
            <option value="1.075">7.5%</option>
            <option value="1.08">8%</option>
            <option value="1.085">8.5%</option>
            <option value="1.09">9%</option>
            <option value="1.095">9.5%</option>
            <option value="1.10">10%</option>
        </select>
    );
};
export default GrowthIndexDropdown;